import {Component, Input, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromQuote from '../../reducers/index';
import * as QuoteActions from '../../actions/quote.action';


@Component({
    selector: 'edit-quote',
    templateUrl : './edit-quote.component.html',
    styleUrls: ['./edit-quote.component.scss']
})

export class EditQuoteComponent implements OnInit{
    form: FormGroup;

    @Input() 
    selectedQuote;

    constructor(private store: Store<fromQuote.State> ) {}

    ngOnInit() {
        this.form = new FormGroup({
            name: new FormControl(this.selectedQuote.name, [Validators.required])
        });
    }

    closeEditQuote() {
        this.store.dispatch(QuoteActions.closeEditQuote());
    }

    onEditQuote() {
        if (this.form.valid) {
            this.store.dispatch(QuoteActions.editQuote({command: {quote: this.selectedQuote, name: this.form.value.name}}));
            this.store.dispatch(QuoteActions.closeEditQuote());
        }
    }
}